import { Component, EventEmitter, Output, ViewChild, VERSION,
  ViewContainerRef,
  Compiler,
  Injector,
  ChangeDetectorRef,} from '@angular/core';
import {ScssThemeChangeService} from './services/scss_theme_change/scss-theme-change.service'
import {TranslateService} from '@ngx-translate/core';
import {BoardService} from "./services/board/board.service";
import {Board} from './modele/boardModel';
import {Observable} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
import {TokenService} from './services/token/token.service';
import {EndpointService} from "./services/endpoint/endpoint.service";
import {User, Owner} from './modele/user/userModel';
import {UserSettings} from "./modele/user/userSettings";
import {Event, Router, NavigationStart,ActivatedRoute, NavigationEnd, NavigationCancel, NavigationError} from "@angular/router";
import {FollowService} from "./services/board/follow/follow.service";
import {ShowhideService} from './services/showhide/showhide.service';
import {NGXLogger} from "ngx-logger";
import { Title, Meta } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import {TourService} from 'ngx-tour-md-menu';


declare let gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'whooosh | Merchandice Shop';
  selector: string = '.main-panel';
  appId = 'day';
  allBoards: Board[] = [];
  isUserLoggedInn: boolean;
  isNewBoard: Observable<Board>;
  checkUserBearerToken: boolean;
  getCurrentUserLiveRequest= new User();
  loading = false;
  isPlaylistOpen:boolean;
  showFooter: boolean = true;
  youAreHere: string;
  @ViewChild('cookieLaw')
  private cookieLawEl: any;
    public dismiss(): void {
        this.cookieLawEl.dismiss();
    }

    log_prefix = this.constructor.name;
    @ViewChild('container', { read: ViewContainerRef })
    container: ViewContainerRef;

  constructor(
      private themeChange: ScssThemeChangeService,
      private translate: TranslateService,
      private router: Router,
      public nav: ShowhideService,
      private metaService: Meta,
      private activatedRoute: ActivatedRoute,
      private titleService: Title,
      private logger: NGXLogger,
      private cookieService: CookieService,
      private tourService: TourService,
      private compiler: Compiler,
      private injector: Injector,
      private cd: ChangeDetectorRef

  ){

      this.router.events.pipe( filter(event => event instanceof NavigationEnd),
      )
        .subscribe(() => {

          var rt = this.getChild(this.activatedRoute)

          rt.data.subscribe(data => {
            this.titleService.setTitle(data.title)

            if (data.description) {
              this.metaService.updateTag({ name: 'description', content: data.description })
            } else {
              this.metaService.removeTag("name='description'")
            }

            if (data.robots) {
              this.metaService.updateTag({ name: 'robots', content: data.robots })
            } else {
              this.metaService.updateTag({ name: 'robots', content: "follow,index" })
            }

            if (data.ogUrl) {
              this.metaService.updateTag({ property: 'og:url', content: data.ogUrl })
            } else {
              this.metaService.updateTag({ property: 'og:url', content: this.router.url })
            }

            if (data.ogTitle) {
              this.metaService.updateTag({ property: 'og:title', content: data.ogTitle })
            } else {
              this.metaService.removeTag("property='og:title'")
            }

            if (data.ogDescription) {
              this.metaService.updateTag({ property: 'og:description', content: data.ogDescription })
            } else {
              this.metaService.removeTag("property='og:description'")
            }

            if (data.ogImage) {
              this.metaService.updateTag({ property: 'og:image', content: data.ogImage })
            } else {
              this.metaService.removeTag("property='og:image'")
            }


          })

        })
    this.router.events.subscribe(event => {

       if(event instanceof NavigationEnd){
           gtag('config', 'UA-100325458-1',
                 {
                   'page_path': event.urlAfterRedirects
                 }
                );
        }
    });
    this.nav.getFooterShowEmitter().subscribe((showfoo => {
            this.showFooter = showfoo
    }))
    this.nav.openPlaylistEmitter().subscribe((new_click => {
            this.isPlaylistOpen = new_click

    }))
    import('./components/board/board.module').then(({ BoardModule }) => {
      // this.compiler.compileModuleAsync(BoardModule).then((moduleFactory) => {
      //   const moduleReference = moduleFactory.create(this.injector);
      //   const componentFactory =
      //     moduleReference.instance.resolveLazyloadedComponent();
      //   this.container.createComponent(
      //     componentFactory,
      //     null,
      //     moduleReference.injector
      //   );
      //   this.cd.detectChanges(); // tells change detection to refresh the view
      // });
    });

      if(this.cookieService.get('whooosh_language') == ''){
         translate.setDefaultLang('en');
      }
      else{
          let lang = this.cookieService.get('whooosh_language')
          translate.setDefaultLang(lang);
      }

      this.themeChange.getThemeEmitter().subscribe(app => {
        this.appId = app
      })
      this.router.events.subscribe((event: Event) => {


            switch (true) {
                case event instanceof NavigationStart: {
                    this.loading = true;
                    break;
                }
                case event instanceof NavigationEnd:
                case event instanceof NavigationCancel:
                case event instanceof NavigationError: {
                    this.loading = false;
                    this.youAreHere = this.router.url.substr(1);
                    break;
                }
                default: {
                    break;
                }
            }
        });
    }
    ngOnInit() {


        this.tourService.initialize([{
            anchorId: 'startTour',
            content: 'keyword_$298',
            title: 'keyword_$297',
            route: this.youAreHere,
            enableBackdrop: false
        },

          {
            anchorId: 'searchTour',
            content: 'keyword_$300',
            title: 'keyword_$299',
            route: this.youAreHere,
            enableBackdrop: false
          },
          {
            anchorId: 'boardTour',
            content: 'keyword_$302',
            title: 'keyword_$301',
            route: 'HerthaBSC',
          },
          {
            anchorId: 'kollektionTour',
            content: 'keyword_$304',
            title: 'keyword_$303',
            route: 'HerthaBSC',
          },
          {
            anchorId: 'createTour',
            content: 'keyword_$306',
            title: 'keyword_$305',
            route: 'register',
            enableBackdrop: false
          },
          {
            anchorId: 'finishTour',
            content: 'keyword_$308',
            title: 'keyword_$307',
            route: 'register',
            enableBackdrop: false
          },


    ]);
      // this.tourService.start();

    }

    onScrollDown() {
        // console.log("scroll down")
    }

    onScrollUp() {
        // console.log("scroll up")
    }

    onActivate(event) {
        window.scroll(0, 0);
    }
    setMyStyles2(){
        if(this.showFooter == true){
            let styles = {
            'display': 'block',
        };
        return styles;
        }
        else{
            let styles = {
            'display': 'none',
        };
        return styles;
        }

    }
    getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }

  }

    onOutletLoaded(component) {
        this.logger.info(this.log_prefix,"app component -> outlet loaded")
        component.user = this.getCurrentUserLiveRequest;
        component.userObservable = new Observable<User>((observer)=>{
            observer.next(this.getCurrentUserLiveRequest);
        })
    }

}
